// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"CandidateModal_modalButtons__xwRWj","wrapUploadText":"CandidateModal_wrapUploadText__rJWRh","uploadText":"CandidateModal_uploadText__pRih_"};